import React, { useContext, useState } from 'react';
import { Card, Input } from 'antd';

import SurveyTemplateContext from '@totem/components/surveyV2/templateDetails/SurveyTemplateContext';
import FormFieldLabel from '@totem/components/ui_components/forms/FormFieldLabel';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { V2_SURVEY_ENDPOINT } from '@totem/utilities/endpoints';

interface localStateType {
  name: string;
  title: string;
  description: string;
  helpText: string;
}

const SurveyTemplateDetailsPane = () => {
  const { surveyTemplateId, data } = useContext(SurveyTemplateContext);
  const { getApiToken } = useContext(UserProfileContext);
  const [localState, setLocalState] = useState<localStateType>(
    typeof data !== 'undefined' && data !== null
      ? {
          name: data.name,
          title: data.title,
          description: data.description,
          helpText: data.helpText,
        }
      : {
          name: '',
          title: '',
          description: '',
          helpText: '',
        },
  );

  const handleSave = () => {
    fetch(`${V2_SURVEY_ENDPOINT}/template/${surveyTemplateId}`, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        name: localState.name,
        title: localState.title,
        description: localState.description,
        helpText: localState.helpText,
      }),
    });
  };

  return (
    <Card>
      <FormFieldLabel>Name</FormFieldLabel>
      <Input
        placeholder="Name"
        value={localState.name}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
          setLocalState({ ...localState, name: value })
        }
        onBlur={handleSave}
      />

      <FormFieldLabel>Title</FormFieldLabel>
      <Input
        placeholder="Title"
        value={localState.title}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
          setLocalState({ ...localState, title: value })
        }
        onBlur={handleSave}
      />

      <FormFieldLabel>Description</FormFieldLabel>
      <Input
        placeholder="Description"
        value={localState.description}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
          setLocalState({ ...localState, description: value })
        }
        onBlur={handleSave}
      />

      <FormFieldLabel>Help Text</FormFieldLabel>
      <Input
        placeholder="Help Text"
        value={localState.helpText}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
          setLocalState({ ...localState, helpText: value })
        }
        onBlur={handleSave}
      />
    </Card>
  );
};

export default SurveyTemplateDetailsPane;
